import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

import { Role } from "@/main/gql/__generated__/graphql"

import { requiredMessage } from "../errorMessage"

export type SalonUserForm = yup.Asserts<typeof salonUserScheme>

export const salonUserScheme = yup.object({
	email: yup
		.string()
		.required(requiredMessage("ユーザーのメールアドレス"))
		.email("メールアドレスの形式が正しくありません"),
	role: yup
		.mixed<Role>()
		.oneOf(["ADMIN", "MEMBER"])
		.required(requiredMessage("役割")),
})

export const salonUserResolver = yupResolver(salonUserScheme)
